export const isValidCVV = (value: string): boolean => {
  const cvv = value.replace(/\D/g, "")

  return cvv.length === 3
}
